<template>
    <div class="radio-group" :class="display">
        <label
            class="radio"
            v-for="(r, i) in items"
            :key="name + i"
            :class="{ 'checked' : checked === r.value }">
            <div class="radio-block">
                <input
                    type="radio"
                    :disabled="disabled"
                    :name="name"
                    :value="r.value"
                    @change="update">
            </div>
            {{r.label}}
        </label>
    </div>
</template>

<script>

    export default {
        name: "OSJRadioGroup",
        props : {
            columns  : Number,
            disabled : Boolean,
            items    : {
                type : Array,
                required : true
            },  
            name     : {
                type : String,
                required : true
            },
            checked : String
        },
        model : {
            prop : "checked"
        },
        methods : {
            update( e ){
                this.$emit( "input", e.target.value )
            }
        },
        computed : {
            display(){
                return [
                    this.columns ? 'col-' + this.columns : undefined
                ]
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/vars";

    .radio{
        display: flex;
        margin-bottom: 0.5rem;
    }

    label{
        &.checked {
            color: $dark-green;
        }
    }

    .radio-block{
        width: 2rem;
        height: 2rem;
        background: white;
        border: 1px solid $pale-gray;
        border-radius: 50%;
        position: relative;
        margin-right: 1rem;

        .checked &{
            background: $dark-green;
            border: 1px solid $dark-green;
        }

        input{
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }
    }

    .radio-group{
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        margin-bottom: 1rem;

        &.col-2 .radio{
            flex-basis: 45%;
        }
        &.col-3 .radio{
            flex-basis: 30%;
        }
        &.col-4 .radio{
            flex-basis: 22%;
        }
        .radio{
            flex-basis: 90%;
        }
    }
</style>